<template>
	<div class="page-top">
		<div class="ass-head" ref="assHead">
			<!-- 返回按钮 -->
			<i v-if="!endTime" class="iconfont icon-back" @click="back" :title="backTitle"></i>
			<!-- 倒计时 -->
			<div v-if="endTime" class="countdown">距离比赛结束还有：{{countdownTime}}</div>
			<!-- 题目编号 -->
			<ul class="topic-num">
				<li v-for="(s, i) in subjectList" :key="i" @click="changeSubjectNum(i)"
					:class="[currentTopic==i&&'active',s.is_submit&&'select']">
					{{ i+1 }}
				</li>
			</ul>
			<div v-show="showSubjectLoding" class="subject-loding">题目加载中，请稍后点击</div>
		</div>
		<!-- 题库或比赛名称 -->
		<div class="list-title" v-if="title">{{ title }}</div>
		<!-- 题目内容 -->
		<div class="subject-con">
			<slot name="content"></slot>
		</div>
		<!-- 底部按钮 -->
		<div class="bottom-btn">
			<slot name="botton">
				<div v-if="showButton.includes('prev')" class="button button-prev" @click="changeSubjectBnt('prev')">上一题</div>
				<div v-if="showButton.includes('next')" class="button button-next" @click="changeSubjectBnt('next')">下一题</div>
				<div v-if="showButton.includes('submit')" class="button button-submit" @click="submitSubject()">提&nbsp;&nbsp;交
				</div>
				<div v-if="showButton.includes('handinparper')" class="button button-handinparper"
					@click="handinparperSubject('active')">交&nbsp;&nbsp;卷</div>
			</slot>
		</div>
	</div>
</template>

<script>
	import {
		getTime,
	} from '@/api/simulationGame'
	export default {
		name: "PageTop",
		components: {},
		props: {
			backTitle: { // 鼠标悬停返回提示语
				type: String,
				default: "返回"
			},
			subjectList: { // 题目列表
				type: Array,
				required: false
			},
			isLookingBack: { // 是否是回看
				type: Boolean,
				default: false
			},
			title: { // 题库或比赛名称，为空则不显示
				type: String,
				default: ""
			},
			endTime: { // 倒计时结束时间，为空则不显示
				type: String,
				default: ""
			},
			showButton: { // 显示按钮
				type: String,
				default: "prev, next, submit, handinparper"
			}
		},
		data() {
			return {
				currentTopic: 0, // 当前选中题目(下标)
				countdownTime: "", // 倒计时
				times: 0, // 时间戳
				showSubjectLoding: false,
				nowTime: new Date().getTime(),
				flag: true,
			}
		},
		created() {
			this.getTime();
			window.addEventListener('keydown', this.handleKeyDown);
		},
		destroyed() {
			window.removeEventListener('keydown', this.handleKeyDown);
		},
		mounted() {
      this.times = new Date().getTime();
		},
		watch: {
			endTime(val) {
				this.setCountdown();
			}
		},
		filters: {},
		computed: {},
		methods: {
			async getTime(){
				let res = await getTime();
				if(res.status == 1) this.nowTime = new Date(res.data.time.date).getTime()
				else this.nowTime = new Date().getTime()
			},
			async setCountdown() { // 设置倒计时
				let endDate = new Date(this.endTime).getTime();
				let distance = endDate - this.nowTime;
				let timer = setInterval(_ => {
					distance -= 1000;
					// 计算剩余时间的小时和分钟
					let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) + 1;
					let second = Math.floor((distance % (1000 * 60)) / (1000)) + 1;
					if (minutes >= 60) {
						hours++;
						minutes = 0;
					}
					// 还剩20、8、2分钟时校准时间
					if(hours == 1 && second == 59 && (minutes == 20 || minutes == 8 || minutes == 2)){
						if(this.flag){ // 节流，每秒最多执行一次
							setTimeout(_ => {
								this.getTime();
								this.flag = true;
							}, 1000)
						}
						this.flag = false;
					}
					if (hours == 0 && minutes == 1) {
						this.countdownTime = `少于1分钟`
					} else {
						this.countdownTime = `${hours}小时 ${minutes}分钟`
					}
					// 如果倒计时结束，清除定时器
					if (distance <= 0) {
					  clearInterval(timer)
            this.countdownTime = '已结束'
						this.handinparperSubject('passive');
					}
				}, 1000);
			},
			back() { // 返回
				this.$emit("back");
			},
			showSubject(num) { // 设置题目
				this.currentTopic = num;
			},
			preventChangeSubject() { // 阻止快速切换题目
				let timeDifference = new Date().getTime() - this.times;
				if (timeDifference <= 2000) {
					this.showSubjectLoding = true;
					setTimeout(_ => {
						this.showSubjectLoding = false;
					}, 2000 - timeDifference)
					return true;
				}
				this.times = new Date().getTime();
				return false
			},
			changeSubjectNum(num) { // 切换题目
				if (this.preventChangeSubject() || this.currentTopic == num) return;
				this.currentTopic = num;
				this.$emit("changeSubject", num);
			},
			changeSubjectBnt(type) { // 点击上一题或下一题
				let current = this.currentTopic;
				let newCurrent = type == 'prev' ? current - 1 : current + 1;
				if (newCurrent < 0) {
					this.$message({
						type: 'warning',
						message: '已经是第一题了',
						showClose: true
					})
				} else if (newCurrent > this.subjectList.length - 1) {
					this.$message({
						type: 'warning',
						message: '已经是最后一题了',
						showClose: true
					})
				} else {
					this.changeSubjectNum(newCurrent);
				}
			},
			handleKeyDown(event) { // 键盘左右键切换上题和下题
				if (event.keyCode === 37) {
					this.changeSubjectBnt('prev');
				} else if (event.keyCode === 39) {
					this.changeSubjectBnt('next');
				}
			},
			submitSubject() { // 点击提交
				this.$emit("submitSubject");
			},
			handinparperSubject(type) { // 交卷
				this.$emit("handinparperSubject", type);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page-top {
		height: 100%;
		display: flex;
		flex-direction: column;
		.ass-head {
			height: 3.8rem;
			line-height: 3.8rem;
			background-color: #252629;
			border-bottom: 0.4rem solid #203B4D;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 1.6rem;
			position: relative;

			.icon-back {
				font-size: 1.68rem;
				cursor: pointer;
				color: #FFF;
				margin-left: 0.4rem;
				margin-right: 3rem;
			}

			.countdown {
				font-size: 1.28rem;
				font-family: Source Han Sans SC;
				font-weight: 500;
				color: #81FFF2;
        user-select: none;
			}

			.topic-num {
				display: flex;
				overflow: auto;
				height: 100%;
				align-items: center;
				flex: 1;
				flex-wrap: wrap;
				justify-content: flex-end;
				position: relative;

				li {
					display: inline-table;
					width: 1.6rem;
					height: 1.6rem;
					text-align: center;
					line-height: 1.6rem;
					color: #FFF;
					font-size: 0.72rem;
					background-color: #748C9A;
					border-radius: 50%;
					margin-left: 0.6rem;
					// margin-bottom: 0.3rem;
					cursor: pointer;
					user-select: none;
				}

				li.wrong {
					background-color: #F56C6C;
				}

				li.correct {
					background-color: #67c23a;
				}

				li.select {
					background-color: #35EAFF;
				}

				li.active {
					background-color: #409EFF;
				}
			}

			.subject-loding {
				position: absolute;
				color: #FF4848;
				font-size: 0.6rem;
				font-weight: bold;
				right: 1.6rem;
				bottom: 0;
				line-height: 1.6;
			}
		}

		.list-title {
			height: 2.2rem;
			line-height: 2.2rem;
			background-color: #259DA7;
			width: 100%;
			padding-left: 2.4rem;
		}

		.subject-con {
			flex: 1;
			margin: 0 0 0.5rem 0;
			overflow: auto;
		}

		.bottom-btn {
			display: flex;
			justify-content: flex-end;
			margin: 0 2rem 1.5rem 0;

			.button {
				width: 7.6rem;
				height: 2.08rem;
				background-size: 100%;
				background-repeat: no-repeat;
				color: #FFF;
				font-size: 1.04rem;
				text-align: center;
				line-height: 2.08rem;
				cursor: pointer;
				margin-left: 1rem;
				user-select: none;
			}

			.button-prev {
				background-image: url(~@/assets/img/preliminaryClassic/ben.png);
			}

			.button-next {
				background-image: url(~@/assets/img/preliminaryClassic/ben.png);
			}

			.button-submit {
				background-image: url(~@/assets/img/preliminaryClassic/join.png);
			}

			.button-handinparper {
				background-image: url(~@/assets/img/preliminaryClassic/add.png);
			}
		}
	}
</style>
